import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktProjectMessageTemplateLinkContainerModel } from '../../../../../../models/aggregates/dgmkt/dgmkt-project';

@Injectable({
  providedIn: 'root',
})
export class DgMktProjectMessageTemplateLinkService extends BaseApiTemplateService<DgMktProjectMessageTemplateLinkContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'project-message-template-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'project-message-template-links';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'project-message-template-links';
    this.httpClient = http;
  }
}
